import { useState } from "react";
import styles from "./RegisterModal.module.css";
import { ClipboardList, X } from "lucide-react";
import { useDispatch, useSelector } from 'react-redux';
import { sendOtp1, verifyOtp1 } from "../../http/http";
import { setMsisdn } from '../../store/slices/msisdnSlice'

const RegisterModal = ({ isOpen, onClose }) => {

  const { userToken } = useSelector(state => state.persisted.userTokenSlice);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const dispatch=useDispatch()
  if (!isOpen) return null;

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!mobile || mobile.length < 10) {
      setMessage("Please enter a valid mobile number");
      return;
    }

    try {
      setLoading(true);
      setMessage("");

      const response = await sendOtp1(mobile,userToken);

      if (response.success) {
        setOtpSent(true);
        setMessage("OTP sent successfully");
      }
    } catch (error) {
      setMessage(error.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp) {
      setMessage("Please enter OTP");
      return;
    }

    try {
      setLoading(true);
      setMessage("");
       dispatch(setMsisdn(mobile));
      const response = await verifyOtp1(mobile, otp,userToken);

      if (response.success) {
        setMessage("Registration successful");

        setTimeout(() => {
          onClose();
        }, 1000);
      }
    } catch (error) {
      setMessage(error.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.closeBtn}
          onClick={onClose}
        >
          <X size={20} />
        </button>

        <div className={styles.header}>
          <ClipboardList size={22} />
          <h2>Register Now</h2>
        </div>

        <form
          className={styles.form}
          onSubmit={
            otpSent
              ? handleVerifyOtp
              : handleSendOtp
          }
        >
         {!otpSent && <div className={styles.formGroup}>
            <label>Mobile Number*</label>

            <input
              type="tel"
              placeholder="XXXX-XXXXX"
              value={mobile}
              disabled={otpSent}
              onChange={(e) =>
                setMobile(e.target.value)
              }
            />
          </div>}

          {otpSent && (
            <div className={styles.formGroup}>
              <label>OTP*</label>

              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) =>
                  setOtp(e.target.value)
                }
              />
            </div>
          )}

          {message && (
            <p className={styles.message}>
              {message}
            </p>
          )}

          <button
            type="submit"
            className={styles.submitBtn}
            disabled={loading}
          >
            {loading
              ? "Please wait..."
              : otpSent
              ? "Verify OTP"
              : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterModal;